/**
 * Placeholder values that sit in a staff-name column but name no one.
 *
 * The EQR field accepts two of them: a partner has not been picked yet, or
 * the engagement does not need a review at all. They are stored upper-cased
 * in `engagements.eqr` / `wf_eng_requests.eqr_name`, so every reader of those
 * columns has to decide whether it is looking at a person or at a placeholder
 * — recipient resolution skips them (workflowMembership), anything that
 * prints a name does too, and the QC35 checklist asks for EQR hours only when
 * a real reviewer is named (qc35Questions).
 *
 * CommonJS on purpose: the API require()s it and the React build imports it.
 */

const EQR_SENTINELS = ['TO BE DETERMINED', 'NOT REQUIRED'];

/** True when a staff-name value is a placeholder rather than a person. */
const isSentinelName = (value) =>
  EQR_SENTINELS.includes(String(value || '').trim().toUpperCase());

module.exports = { EQR_SENTINELS, isSentinelName };
